/** Extra 8px on the in-chat dock (`gap-2` + `mb-2`) so the banner sits 16px above the composer. */
export const AGENT_CREDIT_ALLOWANCE_IN_CHAT_GAP_CLASS = 'mb-2';
